import { uuidv7 } from 'uuidv7';
import { EventLogs } from '../../utils.js';
import { addEventLog } from '../util.js';
import { zql } from '../../schema.js';
import { isSequenceBeforeProduction } from '../../util/patients-therapies.js';
import { buildCancelSequenceOps } from './cancel-protocol-sequences.js';
export async function stopAllPatientTreatment(tx, input, userId) {
    const now = Date.now();
    const characteristics = await tx.run(zql.patientCharacteristics
        .related('patient')
        .where('patientId', '=', input.patientId)
        .orderBy('createdAt', 'desc')
        .limit(1)
        .one());
    const patientName = characteristics?.patient?.fullName ?? '';
    const sequenceOps = [];
    const logSequenceOps = [];
    const [activeProtocols, sequences] = await Promise.all([
        tx.run(zql.patientProtocols
            .related('protocol')
            .where('patientId', '=', input.patientId)
            .where('deletedAt', 'IS', null)
            .where('endDate', 'IS', null)),
        tx.run(zql.patientTherapySequence.where('patientId', '=', input.patientId).where('deletedAt', 'IS', null)),
    ]);
    const activeProtocolIds = new Set(activeProtocols.map(protocol => protocol.id));
    let cancelledPrescriptions = 0;
    for (const seq of sequences) {
        const isInScope = seq.patientProtocolId == null || activeProtocolIds.has(seq.patientProtocolId);
        if (!isInScope || !isSequenceBeforeProduction(seq))
            continue;
        cancelledPrescriptions++;
        const { sequenceOps: cancelOps, logOps } = buildCancelSequenceOps(tx, seq, {
            now,
            userId,
            patientId: input.patientId,
            patientName,
            reason: input.reason,
        });
        sequenceOps.push(...cancelOps);
        logSequenceOps.push(...logOps);
    }
    for (const protocol of activeProtocols) {
        sequenceOps.push(() => tx.mutate.patientProtocols.update({
            id: protocol.id,
            endDate: now,
            updatedAt: now,
            updatedBy: userId,
        }));
    }
    await Promise.all(sequenceOps.map(op => op()));
    await Promise.all(logSequenceOps.map(op => op()));
    if (tx.location === 'server') {
        await addEventLog(tx, {
            id: uuidv7(),
            resource: 'patient',
            resourceId: input.patientId,
            action: 'update',
            domain: 'patient',
            event: EventLogs.PATIENT_TREATMENT_STOPPED,
            status: 'OK',
            performedBy: userId,
            performedAt: now,
            details: {
                patientId: input.patientId,
                patientName,
                stoppedProtocols: activeProtocols.map(p => p.protocol?.name ?? p.id).join(', ') || undefined,
                cancelledPrescriptions: String(cancelledPrescriptions),
                reason: input.reason,
            },
        });
    }
}
//# sourceMappingURL=stop-all-treatment.js.map